import { Stack, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { HighlightBox } from "lib/@components/highlightBox"
import { If } from "lib/@components/switch"
import { Comparison } from "routes/schedule/compare/lib/diff3"
import { Classification } from "routes/schedule/tasks/classification"
import { Frequency } from "routes/schedule/tasks/frequency"
import { SkillSet } from "routes/schedule/tasks/skill-set"
import { Time } from "routes/schedule/tasks/time"
import { useSkills } from "routes/@lib/skills"
import { areSkillSetsSemanticallyEqual } from "../lib/skill-set-comparison"

export function TaskCompareDetails() {
    const { type, task, originalTarget, target } = useBoundContext()
    const [skillsIndex] = useSkills()
    const { title, skillSet, minutes, frequency } = task ?? {}
    const {
        title: otherTitle,
        skillSet: otherSkill,
        minutes: otherMinutes,
        frequency: otherFrequency,
    } = originalTarget ?? {}

    const isSkillIdentical = areSkillSetsSemanticallyEqual(skillSet, otherSkill, skillsIndex)
    const isTimeIdentical = minutes === otherMinutes
    const isFrequencyIdentical =
        frequency?.interval === otherFrequency?.interval && frequency?.period === otherFrequency?.period

    const diffSx = { color: "primary.main", backgroundColor: "grey.300" }
    const borderSx = { border: "2px solid", borderColor: "primary.main", borderRadius: 1 }

    if (!target || !task) return null

    return (
        <Stack mb={2}>
            <If truthy={type}>
                <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle1">{`${type.titleize()} Task`}</Typography>
                </Stack>
            </If>

            <Stack direction="row" alignItems="center" spacing={1}>
                <HighlightBox
                    path="classification"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "40px",
                        width: "40px",
                        outlineColor: "primary.main",
                    }}
                >
                    <Classification classification={task?.classification ?? ""} />
                </HighlightBox>
                <Typography variant="body1" data-cy="task-compare-task-title">
                    <Comparison other={title} original={otherTitle} text={title} />
                </Typography>
            </Stack>
            <Bound comparisonFunction={() => [false, false]} timeLabelSx={!isTimeIdentical ? diffSx : {}}>
                <Stack direction="row" spacing={1} sx={{ alignItems: "center", mt: 1, ml: 3 }}>
                    <SkillSet sx={!isSkillIdentical ? borderSx : {}} />
                    <Frequency labelSx={!isFrequencyIdentical ? { span: diffSx } : {}} />
                    <Time timeLabelSx={{ diffSx }} />
                </Stack>
            </Bound>
        </Stack>
    )
}
